import React, { useRef} from 'react'
import {Row, Col} from 'antd'
import { connect } from 'react-redux'

import './index.scss'
import LeftSide from "pages/Settings/components/LeftSide";
import RightSide from "pages/Settings/components/RightSide";
import {Scrollbar as BaseScrollbar} from "smooth-scrollbar/scrollbar";
import {useHistory} from "react-router-dom";
import GoBack from "components/goBack";
import { useTranslation } from 'react-i18next';



const Settings: React.FC<any> = ({ leftMenuStatus }) => {
  const {t} = useTranslation()
    const scrollbar = useRef<BaseScrollbar | null>(null);
    const history = useHistory();

  return (
      <>
        <Row>
          <Col span={24} className="transfer settings_page"  >

           <GoBack title={t("settings.settings")} />


            <div className={'flex full flex_wrap'} >
                <LeftSide />

                <RightSide />

            </div>

          </Col>
        </Row>
      </>
  )
}
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
});

export default connect(mapStateToProps, null)(Settings)
